
import { IServiceMap } from '@/business/BusinessFormData'
import { IOrderForm } from '@/types/placeOrderTypes'
import { Component, Vue, Watch } from 'vue-property-decorator'
import BasePage from '../BasePage.vue'
import BasicInfo from '../components/BasicInfo.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'
import XdocProjectPlanForWord from '../components/XdocProjectPlanForWord.vue'
import _ from 'lodash'
import { editOrder } from '@/api/placeOrder'
import { Getter } from 'vuex-class'
import { IFormMap } from '@/store/modules/formMap'
import { getDefaultForm } from '../helper'
import { ICustomerAppKey, IOrganization } from '@/store/state'

@Component({
  components: {
    BasePage,
    BasicInfo,
    UploadMaterial,
    XdocProjectPlanForWord,
  },
})
export default class PlaceOrder extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  selectedTab = 'office'
  group = [false, false]
  isIndeterminate = [false, false]
  base_cfg = {
    formula_compatibility_up: false, // 公式兼容性增强
    zx_asssist: false, // 正斜体修复 正斜体辅助

    enable_latex_to_image: false, // 公式扣图
    disable_choice_layout: false, // 选择题选项布局
    enable_layout_one_question_one_page: false, // 一题一页

    image_auto_layout: false, // 图片自动布局  图文布局优化
  }

  type = ''
  name = ''
  reEdit = false

  @Watch('base_cfg', { deep: true })
  updateGroup() {
    // 分组1
    if (this.base_cfg.disable_choice_layout && this.base_cfg.enable_layout_one_question_one_page) {
      this.$set(this.group, 0, true)
      this.$set(this.isIndeterminate, 0, false)
    } else if (!this.base_cfg.disable_choice_layout && !this.base_cfg.enable_layout_one_question_one_page) {
      this.$set(this.group, 0, false)
      this.$set(this.isIndeterminate, 0, false)
    } else {
      this.$set(this.isIndeterminate, 0, true)
    }

    // 分组2
    if (this.base_cfg.formula_compatibility_up && this.base_cfg.zx_asssist && this.base_cfg.enable_latex_to_image) {
      this.$set(this.group, 1, true)
      this.$set(this.isIndeterminate, 1, false)
    } else if (
      !this.base_cfg.formula_compatibility_up &&
      !this.base_cfg.zx_asssist &&
      !this.base_cfg.enable_latex_to_image
    ) {
      this.$set(this.group, 1, false)
      this.$set(this.isIndeterminate, 1, false)
    } else {
      this.$set(this.isIndeterminate, 1, true)
    }
  }

  handleChangeGroup(val: boolean, group: 1 | 2 | 3 | 4) {
    if (group === 1) {
      this.base_cfg.disable_choice_layout = val
      this.base_cfg.enable_layout_one_question_one_page = val
    }

    if (group === 2) {
      this.base_cfg.formula_compatibility_up = val
      this.base_cfg.zx_asssist = val
      this.base_cfg.enable_latex_to_image = val
    }

    this.$set(this.isIndeterminate, group - 1, false)
  }

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]

    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)

    this.base_cfg.enable_layout_one_question_one_page = false
    this.base_cfg.formula_compatibility_up = true
    this.base_cfg.zx_asssist = true
    this.base_cfg.disable_choice_layout = true
  }

  FormChange(form: IOrderForm) {
    this.form = form
  }

  handleSelectChange(val: string) {
    this.form.xdoc_planning.forEach(item => {
      item.config.style_config_data = {
        ...item.config.style_config_data,
        output_ppt_version: val,
      }
    })
  }

  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if (!this.form.xdoc_planning?.length) {
      this.$message.error('请选择要制作的内容')
      return callback(true)
    }

    const names = this.form.xdoc_planning.map(item => item.name)
    if (Array.from(new Set(names)).length !== this.form.xdoc_planning.length) {
      this.$message.error('制作内容中有重名项目')
      return callback(true)
    }

    for (const i of this.form.xdoc_planning) {
      if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(i.name || '')) {
        this.$message.error('制作内容含有非法字符')
        return callback(true)
      }
      if (!i.origin_files!.filter(word => word.type === 1).length) {
        this.$message.error('制作内容中未选择 word 文件')
        return callback(true)
      }
      if (!i.config.style_config_data) {
        this.$message.error('制作内容中未选择样式')
        return callback(true)
      }
    }

    return callback(false)
  }

  submit(formData: any) {
    formData.xdoc_planning &&
      formData.xdoc_planning.map((projetct: any) => {
        projetct.config.style_config_data.output_ppt_version = this.selectedTab
      })

    const styleConfig = formData.xdoc_planning[0].config.style_config_data

    if (Object.keys(styleConfig).length) {
      if (styleConfig?.render_config.global_cfg) {
        // 全局配置
        styleConfig.render_config.global_cfg.disable_choice_layout = !this.base_cfg.disable_choice_layout // 选项自动布局
        if (this.base_cfg.enable_latex_to_image) {
          // 公式抠图
          styleConfig.render_config.global_cfg.enable_latex_to_image = this.base_cfg.enable_latex_to_image
        }
        if (this.base_cfg.enable_layout_one_question_one_page) {
          // 一题一页
          styleConfig.render_config.global_cfg.enable_layout_one_question_one_page =
            this.base_cfg.enable_layout_one_question_one_page
        }
      }
      if (this.base_cfg.formula_compatibility_up) {
        // 题号目录
        styleConfig.render_config.global_cfg.formula_compatibility_up = this.base_cfg.formula_compatibility_up
      }

      if (this.base_cfg.zx_asssist) {
        // 标题目录
        styleConfig.zx_asssist = this.base_cfg.zx_asssist
      }
    }
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }

  async handleSaveForm() {
    await editOrder({ ticket_id: this.order_id, ...this.screenForm(this.form) })
  }
}
